import candidateReducer from './candidate'
import placesReducer from './places'
import utilityReducer from './utility'
import filesReducer from './files'
import workHistoriesReducer from './workHistory'
import educationsReducer from './education'
import skillsReducer from './skills'
import jobExperiencesReducer from './jobExperiences'

export default {
  candidate: candidateReducer,
  places: placesReducer,
  utility: utilityReducer,
  files: filesReducer,
  workHistory: workHistoriesReducer,
  education: educationsReducer,
  skills: skillsReducer,
  jobExperiences: jobExperiencesReducer,
}
